const zIndex = {
  backdrop: 50,
  snackbar: 80,
  drawer: 100,
  modal: 200,
  menu: 300,
};

export default zIndex;
